// extracted by mini-css-extract-plugin
export var equalColumn = "_he-0";